module.exports = __webpack_public_path__ + "media/img/event/logo/padworth-34870020b6fb259d495849364d1f2419.jpg";